import Popup from '../helpers/Popup';
import Tooltip from '../helpers/Tooltip';

function quickActionsButton(e) {
	e.preventDefault();

	let action 	= $(this).data('action');
	let lotID = $(this).parents('ul').eq(0).data('lot');

	let caller = $(this);

	if (action != 'fav')
		return;

	$.ajax({
		type: 'POST',
		url: '/api/lot/favorite',
		data: {
			lot_id: lotID,
			action: $(this).hasClass('quick-actions__button_active') ? 'delete' : 'add'
		},
		success: r => {
			if (r.STATUS == 'OK')
				$(this).toggleClass('quick-actions__button_active');
		},
		error: e => {
			var r = e.responseJSON;
			if (r.MESSAGE != undefined)
			{
				$('#popup-error').find('.msg').text(r.MESSAGE);
				Popup.show('#popup-error', caller);
			}
		}
	});
}

;$(function() {
	$(document).on('click', '.quick-actions__button', quickActionsButton);
});